// extracted by css-extract-rspack-plugin
export default {"timestamp":"ReviewTitle-module__timestamp__lJtUR","commentsCount":"ReviewTitle-module__commentsCount__K80Z2"};